import axios from "axios";
import "./axiosInstance";

// Форма ответа /api/auth/me определяется сервером; клиенту важен сам факт живой сессии.
export type AuthUser = Record<string, unknown>;

// Токены на клиенте не хранятся и не читаются: сервер держит их у себя и
// сам подставляет в запросы, а браузеру отдаёт только HttpOnly-cookie hawk.sid.
// Единственный источник данных о текущем пользователе — GET /api/auth/me.
export const authService = {
    async login(username: string, password: string): Promise<void> {
        await axios.post("/api/auth/login", { username, password });
    },

    async me(): Promise<AuthUser> {
        const response = await axios.get<AuthUser>("/api/auth/me");

        return response.data;
    },

    async logout(): Promise<void> {
        await axios.post("/api/auth/logout");
    },
};
